import { ChangeDetectionStrategy, Component } from '@angular/core';

import { MatIcon } from '@angular/material/icon';

/**
 * An answer in flight, said the same way everywhere: one turning glyph at control height.
 *
 * The colour belongs to whatever the spinner is standing in rather than to the spinner, so it is
 * inherited — a `text-…` class on the element is all it takes.
 */
@Component({
  selector: 'guarantees-spinner',
  standalone: true,
  imports: [MatIcon],
  host: { class: 'inline-flex shrink-0 items-center' },
  template: `<mat-icon class="h-4! w-4! shrink-0 animate-spin text-base! leading-4!">progress_activity</mat-icon>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpinnerComponent {}
